export const BLOCK_TYPE = {
    FEATURE: "FEATURE",
    BEST_SELLING: "BEST_SELLING",
};
